import React from 'react'
import classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCrown } from '@fortawesome/pro-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import { AvatarSizes } from 'design-system/avatar/src/resources/Avatar.enum'
import Avatar from 'design-system/avatar'
import avatarDefault from 'assets/avatar-loading-xxl.svg'
import CommonToolTip from '../tooltip/commonToolTip'
import styles from './UserAvatar.module.scss'

interface IAvatarUserProps {
  user: {
    fullName?: string | null
    avatar?: string | null
    lastname?: string | null
    name?: string | null
    position?: string | null
    /** Admin LMS = AbacRole is_default */
    isDefaultAbacAdmin?: boolean
  }
  className?: string
  showAdmin?: boolean
  showPosition?: boolean
  classes?: { userName?: string }
  disabled?: boolean
}

const UserAvatar: React.FC<IAvatarUserProps> = ({
  user,
  className,
  children,
  showAdmin = false,
  showPosition = true,
  classes,
  disabled,
}) => {
  const fullName = user.fullName
    ? user.fullName
    : `${user.name} ${user.lastname}`
  const avatar = user.avatar ? user.avatar : avatarDefault

  const { t } = useTranslation()
  const { userName } = { ...classes }
  return (
    <div
      className={`d-flex align-items-center ${styles.container} ${
        className || ''
      }`}
    >
      <Avatar
        src={avatar}
        sizes={AvatarSizes.Medium}
        className={`${styles.img} mr-2 avatarImg`}
      />
      <div className="d-inline-block w-100">
        <p
          className={classNames(
            `m-0 pt-2 basic-title ${styles.userName}`,
            userName,
            disabled && styles.disabled
          )}
        >
          {fullName}
          {showAdmin && user.isDefaultAbacAdmin && (
            <CommonToolTip
              text={t('configuration.user.isAdmin')}
              position="right"
              className={styles.tabsTooltip}
            >
              <FontAwesomeIcon
                icon={faCrown}
                className={`ml-1 ${styles.adminIcon}`}
              />
            </CommonToolTip>
          )}
        </p>
        {showPosition && (
          <small
            className={`grey-darken basic-position ${styles.userPosition}`}
          >
            {user.position}
          </small>
        )}
        {children}
      </div>
    </div>
  )
}

export default UserAvatar
